import(/* webpackMode: "eager", webpackExports: ["DropdownMenu","DropdownMenuTrigger","DropdownMenuItem"] */ "/vercel/path0/components/ui/dropdown-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ui/form.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip","TooltipTrigger","TooltipContent"] */ "/vercel/path0/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DropdownMenuContent"] */ "/vercel/path0/node_modules/.pnpm/@radix-ui+react-dropdown-menu@2.1.1_@types+react-dom@18.3.0_@types+react@18.3.5_react-dom@18._2x7jg6mnrazeumtsnkx7xsfaby/node_modules/@radix-ui/react-dropdown-menu/dist/index.mjs");
